import { BehaviorSubject, map, Observable, tap } from 'rxjs';
import { State } from '@progress/kendo-data-query';
import { GridDataResult } from '@progress/kendo-angular-grid';

import { DataAccessService } from '.';
import { IQueryParam } from '../../';

export class EntityDataService extends BehaviorSubject<GridDataResult> {
    public loading = false;

    constructor(
        protected service_api: string,
        protected dataAccessService: DataAccessService
    ) {
        super({ data: [], total: 0 });
    }

    public query(qryParam?: IQueryParam): void {
        this.fetch(qryParam).subscribe((x) => super.next(x));
    }

    public get(dataState: State): Observable<GridDataResult> {
        if (!dataState.skip) {
            dataState.skip = 0;
        }
        if (!dataState.sort || dataState.sort.length === 0) {
            dataState.sort = [{ field: 'name', dir: 'asc' }];
        }
        if (dataState.take === undefined || dataState.take === 0) {
            dataState.take = 10;
        }
        const qryParam = {
            pageSize: dataState.take,
            pageIndex: (dataState.skip ?? 0) / dataState.take,
            orderBy: dataState.sort
                ? {
                      field: dataState.sort[0].field,
                      desc: dataState.sort[0].dir === 'desc',
                  }
                : undefined,
        };
        return this.fetch(qryParam);
    }

    protected fetch(qryParam?: IQueryParam): Observable<GridDataResult> {
        this.loading = true;
        return this.dataAccessService
            .queryEntity(this.service_api, 'qry', qryParam)
            .pipe(
                map(
                    (r) =>
                        <GridDataResult>{
                            data: r.items || [],
                            total: r.totalCount ?? 0,
                        }
                ),
                tap(() => (this.loading = false))
            );
    }
}
